import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

export interface TutorialDialogData {
  url: string;
}

@Component({
    selector: 'app-tutorial-dialog',
    templateUrl: './tutorial-dialog.component.html',
    styleUrls: ['./tutorial-dialog.component.css'],
    standalone: false
})
export class TutorialDialogComponent {
  public safeUrl: any;

  constructor(
    public dialogRef: MatDialogRef<TutorialDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TutorialDialogData,
    private _sanitizer: DomSanitizer) {
    if (this.data.url) {
      this.safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.data.url}`);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
